var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",attrs:{"id":"app"}},[_c('KeepAlive',{attrs:{"include":['ChatView']}},[_c('router-view')],1),_c('NotificationCenter',{staticClass:"tw-fixed tw-bottom-2 tw-right-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }